import script from "./PaymentCancelledNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentCancelledNotice.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__